function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import deepmerge from 'deepmerge';
export const sizes = {
  xxs: 390,
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200
};
export const getSizes = () => {
  const width = window.innerWidth;
  return {
    xxs: width < sizes.xxs,
    xs: width < sizes.xs,
    sm: width < sizes.sm,
    md: width < sizes.md,
    lg: width < sizes.lg,
    xl: width >= sizes.lg
  };
};

const withSizes = Component => {
  var _temp;

  return _temp = class extends React.Component {
    constructor(props) {
      super(props);

      _defineProperty(this, "getStyle", style => {
        const {
          xxs,
          xs,
          sm,
          md,
          lg,
          xl
        } = this.state;
        let newStyle = style;

        if (xl && typeof style.xl === 'object') {
          newStyle = deepmerge(newStyle, style.xl);
        }

        if (lg && typeof style.lg === 'object') {
          newStyle = deepmerge(newStyle, style.lg);
        }

        if (md && typeof style.md === 'object') {
          newStyle = deepmerge(newStyle, style.md);
        }

        if (sm && typeof style.sm === 'object') {
          newStyle = deepmerge(newStyle, style.sm);
        }

        if (xs && typeof style.xs === 'object') {
          newStyle = deepmerge(newStyle, style.xs);
        }

        if (xxs && typeof style.xxs === 'object') {
          newStyle = deepmerge(newStyle, style.xxs);
        }

        return newStyle;
      });

      _defineProperty(this, "updateDimensions", () => {
        this.setState(getSizes());
      });

      this.state = getSizes();
    }

    componentDidMount() {
      this.updateDimensions();
      window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
    }

    render() {
      return (
        /*#__PURE__*/
        React.createElement(Component, _extends({
          getStyle: this.getStyle
        }, this.props, this.state))
      );
    }

  }, _temp;
};

export default withSizes;